import React from 'react'
import Navbar from '../Header/Navbar'
import RoutineHero from './RoutineFPO/RoutineHero'
import RoutineSection from './RoutineFPO/RoutineSection'
import RoutineHeroTrust from './RoutineFPO/RoutineHeroTrust'
import Footer from '../Footer/Footer'

function RoutineFPO() {
    return (
        <div>
        <RoutineHero/>
        <RoutineSection/>
        <RoutineHeroTrust/>
        <Footer/>
        </div>
    )
}

export default RoutineFPO
